export const validateSelectionCount = (
	tiers: number[],
	selections: number
): string | null => {
	tiers = tiers.slice().sort((a, b) => a - b);

	const minTier = tiers[0];
	const maxTier = tiers[tiers.length - 1];

	if (selections < minTier) {
		return `Selecione mais ${minTier - selections} ${
			minTier - selections === 1 ? 'pick' : 'picks'
		} `;
	}

	if (tiers.includes(selections)) {
		return null;
	}

	if (selections > maxTier) {
		const removeCount = selections - maxTier;
		return `Remova ${removeCount} pick${removeCount > 1 ? 's' : ''}`;
	}

	let lowerTier = minTier;
	let higherTier = maxTier;

	for (let i = 0; i < tiers.length - 1; i++) {
		if (selections > tiers[i] && selections < tiers[i + 1]) {
			lowerTier = tiers[i];
			higherTier = tiers[i + 1];
			break;
		}
	}

	const removeCount = selections - lowerTier;
	const addCount = higherTier - selections;

	return `Remova ${removeCount} pick${
		removeCount > 1 ? 's' : ''
	} ou selecione mais ${addCount} pick${addCount > 1 ? 's' : ''}`;
};
